const TEMP_DRAFTS_KEY = "temp_drafts";

export const getLocalStorageData = () => {
  const storedPastes = localStorage.getItem(TEMP_DRAFTS_KEY);
  return storedPastes ? JSON.parse(storedPastes) : [];
};

export const updateLocalStorageData = (id, data) => {
  var isAdded = false;
  const storedPastes = localStorage.getItem(TEMP_DRAFTS_KEY);
  const drafts = storedPastes ? JSON.parse(storedPastes) : [];
  const updatedDrafts = drafts.map((draft) => {
    if (id === draft.id) {
      isAdded = true;
      return { ...draft, ...data }; // case draft exists
    }
    return draft;
  });
  if (!isAdded) {
    updatedDrafts.push(data); // case new draft
  }
  localStorage.setItem(TEMP_DRAFTS_KEY, JSON.stringify(updatedDrafts));
};

// hello

export const deleteDraftFromLocalStorage = (id) => {
  const storedPastes = localStorage.getItem(TEMP_DRAFTS_KEY);
  const drafts = storedPastes ? JSON.parse(storedPastes) : [];
  const updatedDrafts = drafts.filter((draft) => draft.id !== id);
  localStorage.setItem(TEMP_DRAFTS_KEY, JSON.stringify(updatedDrafts));
};

export const saveLocalStorageData = (data) => {
  localStorage.setItem(TEMP_DRAFTS_KEY, JSON.stringify(data));
};
